import React from 'react';

import Icon from './icons/Icon';
import Link from './Link';

const MaximizeToolbarIcon = props => {
    const {icon} = props;

    const handleOpenSidePanel = () => {
        app.store.dispatch(app.actions.ui.sidePanel.maximize(true));
    };

    return (
        <Link className="mobile-only" onClick={handleOpenSidePanel}>
            {icon || <Icon
                style={{
                    transform: 'rotate(270deg)',
                }}
                src={`/img/svg/upload-solid.svg`}
            />}
        </Link>
    );
};

export default MaximizeToolbarIcon;
